<template>
  <div 
    :class="{'internalTitleDescriptionImageParallax--contentLeftPosition' : contentLeft}"
    class="internalTitleDescriptionImageParallax">
    <div class="internalTitleDescriptionImageParallax__contents">
      <div 
        v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
        v-for="(content, index) of contents"
        :key="index"
        class="internalTitleDescriptionImageParallax__contents__element">
        <h4 
          v-if="typeof content.fields.frontendTitle !== 'undefined'"
          v-html="content.fields.frontendTitle.replace(/\n/gi, '<br />')"/>
        <div 
          v-if="typeof content.fields.description !== 'undefined'"
          v-html="$_htmlConverter(content.fields.description)"
          class="internalTitleDescriptionImageParallax__contents__element__description">
        </div>
        <p 
          v-if="typeof content.fields.label !== 'undefined'"
          class="internalTitleDescriptionImageParallax__contents__element__label"
          v-html="content.fields.label.replace(/\n/gi, '<br />')">
        </p>
        <div 
          v-if="typeof content.fields.labelContent !== 'undefined'"
          v-html="$_htmlConverter(content.fields.labelContent)"
          class="internalTitleDescriptionImageParallax__contents__element__label-content">
        </div>
      </div>
    </div>
    <div 
      v-rellax="{ rellaxSpeed, adjustRellax }"
      class="internalTitleDescriptionImageParallax__pictures"
      v-lazy-container="{ selector: 'img' }">
      <picture 
        v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
        v-for="(image, index) of images"
        :key="index"
        class="internalTitleDescriptionImageParallax__picture">
        <source :srcset="image.fields.landscape.fields.file.url" media="(orientation: landscape)">
        <img 
          :data-src="image.fields.portrait.fields.file.url"
          :data-loading="lazyLoading"
          :width="orientation === 'landscape' ? image.fields.landscape.fields.file.details.image.width : image.fields.portrait.fields.file.details.image.width"
          :height="orientation === 'landscape' ? image.fields.landscape.fields.file.details.image.height : image.fields.portrait.fields.file.details.image.height">
      </picture>
    </div>
  </div>
</template>

<script>
import Rellax from 'rellax'
import waypointEffect from '@/mixins/waypointEffect.js'

import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
      return `<div class="blog-post__content-container__image"><img src="${node.data.target.fields.file.url}" alt="" width="${node.data.target.fields.file.details.image.width}" height="${node.data.target.fields.file.details.image.height}" alt="${node.data.target.fields.title}"></div>`
    },
    [INLINES.ENTRY_HYPERLINK]: (node, next) => {
      const contentTypeId = node.data.target.sys.contentType.sys.id
      const map = {
        'products': 'prodotto',
        'category': 'categoria',
        'posts': 'cosa-usare-per',
        'tags': 'tag'
      }
      if (typeof map[contentTypeId] !== 'undefined'){
        return `<a class="underline_link" target="_blank" href="/${map[contentTypeId]}/${node.data.target.fields.slug}/">${node.content[0].value}</a>`
      }
      else return '<strong>Problem during link render</strong>'
    },
    [INLINES.HYPERLINK]: (node, next) => {
      return `<a class="underline_link" target="_blank" href="${node.data.uri}">${node.content[0].value}</a>`
    }
  },
  renderMark: {
    // Example
    [MARKS.BOLD]: text => `<strong>${text}</strong>`
    // [MARKS.CODE]
  }
}

export default {
  name: 'InternalTitleDescriptionImageParallax',
  mixins: [waypointEffect],
  data: () => ({
    rellaxRef: undefined,
    adjustRellax: 1,
    lazyLoading: require('@/assets/services/ingombro.png'),
    orientation: window.matchMedia("(orientation: portrait)").matches ? 'portrait' : 'landscape'
  }),
  props: {
    images: {
      type: Array,
      required: false
    },
    contents: {
      type: Array,
      required: false
    },
    contentLeft: {
      type: Boolean,
      default: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  methods: {
    $_htmlConverter (field) {
      return documentToHtmlString(field, options).replace(/\n/g, `</br>`)
    }
  },
  mounted () {
    setTimeout(
      () => this.adjustRellax = this.adjustRellax + 1,
      1000
    )
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined'){
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
            percentage: 0.5
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated(el, binding, vnode){
        if (typeof binding.value.rellaxSpeed !== 'undefined') {
          if (binding.value.rellaxSpeed !== binding.oldValue.rellaxSpeed){
          vnode.context.$data.rellax.destroy()
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
            percentage: 0.5
          })
          vnode.context.$data.rellax = rellaxRef
          }
          else vnode.context.$data.rellax.refresh()
        }
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./internalTitleDescImgParallax.scss";
  @import "./waypoint-effects.scss";
</style>
  